var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSinavahazir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0439 16.4114L28.2839 26.0571L19.8115 20.9371L11.3391 26.0571L13.5639 16.4114L6.09724 9.90476L15.9563 9.08191L19.8115 0L23.6668 9.08191L33.5258 9.90476L26.0439 16.4114ZM1.52581 17.4171C1.81534 17.4171 2.10486 17.3257 2.36391 17.1581L7.2401 13.9429L4.84772 11.8705L0.687718 14.6133C-0.0147583 15.0705 -0.209806 16 0.245813 16.7619C0.550575 17.1733 1.03819 17.4171 1.52581 17.4171ZM0.245813 31.3143C0.550575 31.7562 1.03819 32 1.52581 32C1.81534 32 2.10486 31.9238 2.36391 31.7562L8.62676 27.6267L9.14486 25.539L9.61724 23.3295L0.687718 29.1962C-0.0147583 29.6686 -0.209806 30.6133 0.245813 31.3143ZM0.687718 21.9124C-0.0147583 22.3695 -0.209806 23.3143 0.245813 24.0152C0.550575 24.4724 1.03819 24.701 1.52581 24.701C1.81534 24.701 2.10486 24.6248 2.36391 24.4571L10.623 19.0476L11.0344 17.2343L9.63248 16L0.687718 21.9124Z",
    fill: "#3733BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinavahazir);
export default __webpack_public_path__ + "static/media/sinavahazir.a0f27eaa036ef5eb243c3875e039de99.svg";
export { ForwardRef as ReactComponent };